import { useEffect, useState } from "react";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

function FibonacciNumberSeries() {
  const [inputValue, setInputValue] = useState({});
  const [count, setCount] = useState([]);
  const [count1, setCount1] = useState([]);
  const [coma, setComa] = useState("  ");
  const [copy, setCopy] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [errors, setErrors] = useState(null);

  const handleOnChange = (e) => {
    setCopy(false);
    const { name, value } = e.target;
    if (name === "character") {
      setComa(value);
    } else {
      setInputValue({ ...inputValue, [name]: value });
      setCount([]);
    }
    setErrors("");
  };

  useEffect(() => {
    if (count1?.length > 0) {
      const formattedString = count1.join(coma || " ");
      setTextValue(formattedString);
    } else {
      setTextValue("");
    }
  }, [count1, coma]);

  // Validates the input form
  const validateForm = () => {
    if (!inputValue?.startNumber) {
      setErrors("* Please enter a valid number");
      return false;
    }
    setErrors(null);
    return true;
  };

  // Handles Fibonacci sequence generation
  const handleOnSubmitArithmetic = () => {
    if (!validateForm()) return;

    const startNumber = parseInt(inputValue.startNumber, 10);
    const fibonacciSequence = generateFibonacci(startNumber);

    setCount1(fibonacciSequence);
    setCopy(false);
  };

  // Generates a Fibonacci sequence up to a given number of terms
  const generateFibonacci = (terms) => {
    const sequence = [];
    let n1 = 0,
      n2 = 1,
      nextTerm;

    for (let i = 0; i < terms; i++) {
      sequence.push(n1);
      nextTerm = n1 + n2;
      n1 = n2;
      n2 = nextTerm;
    }

    return sequence;
  };
  return (
    <>
      <div className="commom-box-new aritmetic-top-alignment">
        <div className="aritmetic-two-col-grid">
          <div className="aritmetic-two-col-grid-items">
            <div className="input-new">
              <label>Enter the number of terms</label>
              <input
                type="number"
                name="startNumber"
                value={inputValue?.startNumber}
                placeholder="10"
                onChange={(e) => {
                  handleOnChange(e);
                }}
                className={errors && "error-input"}
              />
              <span className="text-sm text-red-700">{errors}</span>
            </div>
          </div>

          <div className="aritmetic-two-col-grid-items">
            <div className="input-new">
              <label>
                Separate elements in the Fibonacci series by this character.
              </label>
              <input
                type="text"
                name="character"
                onChange={handleOnChange}
                placeholder=" + "
              />
            </div>
          </div>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleOnSubmitArithmetic}>Genrate Now</button>
      </div>
      {textValue && (
        <div className="main-globally-counter-box">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(textValue)} />
            {copy && (
              <div>
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="counter-text-area">
            <textarea
              value={textValue}
              placeholder="0  1  1  2  3  5  8  13  21  34"
              disabled={true}
              className="text-black"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default FibonacciNumberSeries;
